import React, { useEffect, useState } from "react";
import Button from "../../../../../../../../../../../components/ripple/Button";
import styles from "./AddPlaceholder.module.scss";

export default function AddPlaceholder({
                                           children,
                                           reveal,
                                           watchReveal,
                                           title,
                                           className,
                                           margin,
                                           messages,
                                           container,
                                           target,
                                           alwaysHidden,
                                           disabled,
                                           onClick,
                                           small,
                                       }) {

    const [_reveal, setReveal] = useState(reveal || false);

    useEffect(() => {
        if (watchReveal) setReveal(reveal)
    }, [reveal]);

    const disabledButton = disabled;
    const highlightedButton = messages?.find(m => (container && m.container === container || !container) && m.target === target);

    const smallStyles = small ? ' ' + styles[`add--small`] : '';
    const disabledButtonStyles = disabledButton ? ' ' + styles['add--disabled'] : '';
    const highlightedButtonStyles = highlightedButton ? ' ' + styles[`add--highlight`] : '';


    if (!!_reveal) {
        return children
    } else {
        return (
            <Button
                className={`${styles.add}${smallStyles}${disabledButtonStyles}${highlightedButtonStyles}${className ? ' ' + className : ''}`}
                title={title && title}
                onClick={() => {
                    if (!alwaysHidden && !_reveal) setReveal(true);
                    if (onClick) onClick();
                }}
                iconLeft='fas fa-plus'
                displayType={highlightedButton ? 'contained' : 'text'}
                type='button'
                disabled={disabledButton}
                visuals={{
                    borderRadius: small ? '1.6rem' : '2rem',
                    height: small ? '3.2rem' : '4rem',
                    colorBasic: highlightedButton
                        ? highlightedButton.type === 'error'
                            ? ['var(--colorFontError)']
                            : highlightedButton.type === 'warning' ? ['var(--colorFontWarning)'] : []
                        : [],
                    margin,
                }}
            />
        )
    }
}